import { GoogleOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input } from "@p0security/ui";
import { AllIntegrationLogos } from "components/Integrations/IntegrationLogo";
import { useFlags } from "launchdarkly-react-client-sdk";
import * as React from "react";

import { useCreateAccountPageStore } from "../../../store/createAccountStore";
import { validateWorkEmailDomain } from "../utils";
import { EmailButton } from "./styles";

type Props = {
  handleGoogleSignUp: () => void;
  handleEntraSignUp: () => void;
  onEmailSignUp: ({ email }: { email: string }) => void;
};

const SignUpForm: React.FC<Props> = ({
  handleGoogleSignUp,
  handleEntraSignUp,
  onEmailSignUp,
}) => {
  const { isGoogleSsoLoading, isEntraSsoLoading } = useCreateAccountPageStore();
  const flags = useFlags();

  return (
    <>
      <Form onFinish={onEmailSignUp} layout="vertical">
        <Form.Item
          name="email"
          rules={
            flags.allowWorkEmail
              ? [
                  {
                    validator: validateWorkEmailDomain,
                  },
                ]
              : [
                  {
                    type: "email",
                    message: "The input is not a valid email!",
                  },
                ]
          }
        >
          <Input
            type="email"
            placeholder="Enter your business email address"
            size="large"
          />
        </Form.Item>
        <EmailButton block size="large" htmlType="submit">
          Sign up with email
        </EmailButton>
      </Form>
      <Divider plain>OR CONTINUE WITH</Divider>
      <Button
        block
        size="large"
        icon={<GoogleOutlined />}
        loading={isGoogleSsoLoading}
        disabled={isGoogleSsoLoading || isEntraSsoLoading}
        onClick={handleGoogleSignUp}
      >
        Google
      </Button>
      <Button
        block
        size="large"
        icon={AllIntegrationLogos["azure-ad"]}
        loading={isEntraSsoLoading}
        disabled={isGoogleSsoLoading || isEntraSsoLoading}
        onClick={handleEntraSignUp}
      >
        Entra ID
      </Button>
    </>
  );
};

export default SignUpForm;
